import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component } from "@angular/core";

/* eslint-disable @tseslint/no-extraneous-class */
@Component({
  selector: "app-shared-notify-chip-value",
  templateUrl: "notify-chip-value.component.html",
  styleUrl: "notify-chip-value.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule
  ]
})
export class NotifyChipValueComponent {}
/* eslint-enable @tseslint/no-extraneous-class */
